<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app my-4">
    <div class="content-app">
        <h3 class="section-title">
            <i class="fa-solid fa-house me-2 text-primary"></i>
            Dashboard
        </h3>

        <div class="row g-4 mb-4">
            <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                <div class="card rounded-4 shadow-sm border-0">
                    <div class="card-body p-4">
                        <div *ngIf="isLoading" class="text-center my-3">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Cargando...</span>
                            </div>
                            <p class="mt-2">Cargando información...</p>
                        </div>

                        <!-- Sección cuando no se ha encontrado la información del candidato -->
                        <div *ngIf="!isLoading && !isFound" class="alert alert-warning text-center" role="alert">
                            No se ha encontrado la información del candidato.
                        </div>

                        <!-- Sección principal cuando se encontró la data -->
                        <div *ngIf="!isLoading && isFound">
                            <div class="d-flex align-items-center mb-4">
                                <div class="position-relative me-3">
                                    <img [src]="profileImage" onerror="this.src='assets/Images/user.png'; this.error=null;" alt="candidato" 
                                        class="rounded-circle border border-3 border-light shadow" style="width: 100px; height: 100px; object-fit: cover;" />
                                </div>
                                <div>
                                    <div class="text-secondary small fw-medium mb-1">Bienvenido</div>
                                    <h3 class="text-primary mb-1 fw-bold">{{candidate?.firstName}} {{candidate?.lastName}}</h3>
                                    <div class="d-flex flex-column gap-1 text-secondary small">
                                        <div class="d-flex align-items-center">
                                            <div class="icon-bg me-2">
                                                <i class="fa-regular fa-envelope"></i>
                                            </div>
                                            <span>{{candidate?.email}}</span>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="icon-bg me-2">
                                                <i class="fa-solid fa-mobile-screen"></i>
                                            </div>
                                            <span>{{candidate?.primaryPhone}}</span>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <div class="icon-bg me-2">
                                                <i class="fa-solid fa-location-dot"></i>
                                            </div>
                                            <span>{{principalAddress?.stateName}}, {{principalAddress?.countryName}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <hr class="my-3" />
                        
                        <div class="row g-4">
                            <div class="col-md-6">
                                <div class="stats-card p-3 rounded-4 border">
                                    <div class="d-flex align-items-center">
                                        <div class="icon-container me-3">
                                            <i class="fa-solid fa-id-card-clip fa-2x text-primary"></i>
                                        </div>
                                        <div>
                                            <h3 class="text-primary fw-bold mb-0">{{jobApplicationsCount | number}}</h3>
                                            <div class="text-secondary small">Aplicaciones realizadas</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="stats-card p-3 rounded-4 border">
                                    <div class="d-flex align-items-center">
                                        <div class="icon-container me-3">
                                            <i class="fa-solid fa-eye fa-2x text-success"></i>
                                        </div>
                                        <div>
                                            <h3 class="text-success fw-bold mb-0">{{ candidate?.profileViewsCount || 0 }}</h3>
                                            <div class="text-secondary small">Vistas del perfil</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
                <!-- <div class="card rounded-4 shadow-sm border-0 mb-4">
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                            <div class="icon-container me-3">
                                <i class="fa-solid fa-person-running fa-2x text-primary"></i>
                            </div>
                            <div>
                                <h2 class="text-primary fw-bold mb-0">0</h2>
                                <div class="text-secondary">Ofertas publicadas en el último día</div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="card rounded-4 shadow-sm border-0">
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center">
                            <div class="icon-container me-3">
                                <i class="fa-solid fa-money-check-dollar fa-2x text-primary"></i>
                            </div>
                            <div>
                                <h2 class="text-primary fw-bold mb-0">RD$ 1,520,450,445</h2>
                                <div class="text-secondary">Aproximados en concepto de nómina</div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="row mb-4">
            <div class="col-12 mb-3">
                <h3 class="section-title">
                    <i class="fa-solid fa-briefcase me-2 text-primary"></i>
                    Ofertas laborales a las que apliqué
                </h3>
            </div>
            <div class="col-12">
                <app-job-offer-list [appliedOffers]="true"/>
            </div>
        </div>
    </div>
</div>